import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={130.448}
      height={127.148}
      viewBox="0 0 130.448 127.148"
      {...props}
    >
      <title>
        Iso 27001
      </title>
      <defs>
        <style>
          {
            ".prefix__a{fill:#e75109}.prefix__b{fill:#6e696b}.prefix__d{fill:#fff}.prefix__e{fill:none;stroke:#fff;stroke-miterlimit:3.864;stroke-width:.073px}"
          }
        </style>
      </defs>
      <path
        className="prefix__a"
        d="M61.385 76.671l-10.438-10.44V50.41l10.438 10.442 23.764-23.757a33.481 33.481 0 106.559 9.25z"
      />
      <path
        className="prefix__b"
        d="M81.844 121.95c-3.056-.935-3.68-3.579-3.482-6.5h4.422c0 2.01.08 3.7 2.507 3.7a2.1 2.1 0 002.229-2.384c0-3.8-8.9-4.034-8.9-10.313 0-3.308 1.581-5.933 6.967-5.933 4.307 0 6.442 1.923 6.145 6.34h-4.3c0-1.581-.262-3.183-2.045-3.183a2.055 2.055 0 00-2.293 2.238c0 4.008 8.9 3.664 8.9 10.285 0 3.657-1.791 5.158-3.989 5.747zM102.759 107.361c.024-1.963-.3-3.68-2.641-3.68-2.75 0-2.75 3.709-2.75 7.789 0 6.607.653 7.771 3.164 7.771a6.953 6.953 0 002.2-.4v-4.678h-2.41v-3.254h6.823v10.706c-.462.082-1.206.222-2.045.335h-7.565c-4.1-1.013-4.644-4.265-4.644-10.706 0-5.323.266-10.72 7.493-10.72 4.333 0 7.028 2.429 6.762 6.838zM115.498 100.523c3.857 0 5.98 1.5 6.263 4.894v1.447h-4.3c0-1.536-.382-3.183-2.17-3.183a2.054 2.054 0 00-2.29 2.241c0 3.7 7.61 3.687 8.758 8.9v3.054a4.888 4.888 0 01-3.85 4.078h-6.15c-3.056-.935-3.676-3.577-3.489-6.5h4.415c0 2.01.08 3.706 2.521 3.706a2.1 2.1 0 002.215-2.387c0-3.8-8.895-4.031-8.895-10.311 0-3.31 1.583-5.916 6.972-5.935"
      />
      <path className="prefix__a" d="M65.077 121.944h65.371v.844H65.077z" />
      <path
        className="prefix__a"
        d="M121.738 96.636h.841v30.512h-.841zM11.701 65.761l-9.586 1.045-.285.032.2 1.744 9.864-1.079zM6.124 76.028c1.755-.368 2.182-1.894 2.528-3.12.269-.964.5-1.8 1.249-1.951a1.02 1.02 0 01.815.1 1.234 1.234 0 01.488.811 1.137 1.137 0 01-.085.884 1.557 1.557 0 01-1.053.521l-.287.054.379 1.777.266-.042a2.956 2.956 0 002.071-1.131 2.9 2.9 0 00.3-2.295 2.766 2.766 0 00-3.388-2.406c-1.645.344-2.045 1.779-2.4 3.044-.278 1-.518 1.859-1.289 2.024-.825.158-1.305-.2-1.487-1.117a1.317 1.317 0 01.1-.914 1.416 1.416 0 01.994-.62l.54-.1-.356-1.722-.273.052a3.385 3.385 0 00-2.293 1.239 3.023 3.023 0 00-.287 2.384 3.379 3.379 0 001.317 2.231 2.461 2.461 0 001.374.386 3.851 3.851 0 00.777-.089zM12.735 82.639c2-.742 2.735-2.267 2.024-4.187a3.162 3.162 0 00-1.593-1.909 3.419 3.419 0 00-2.653.035l-2.879 1.053a4.23 4.23 0 00-2.6 1.941 3.089 3.089 0 00.045 2.439 2.746 2.746 0 002.693 2.121 6.279 6.279 0 002.088-.434zm.558-3.65c.111.337.45 1.374-1.133 1.96l-2.971 1.077a2.912 2.912 0 01-2.019.25 1.3 1.3 0 01-.62-.825 1.284 1.284 0 01-.047-1.011c.189-.405.745-.768 1.7-1.112l2.955-1.093a2.619 2.619 0 01.879-.177 1.342 1.342 0 01.58.12 1.371 1.371 0 01.676.812zM12.79 91.055c2.222.311 3.235.457 4.663-.389a2.356 2.356 0 00.9-3.65 2.476 2.476 0 00-1.557-1.239 2.7 2.7 0 00-2.08.528l-.219.151.9 1.527.247-.151a1.427 1.427 0 01.987-.3.7.7 0 01.417.358c.283.478.165.862-.363 1.176-.975.584-1.753.514-4.328.262-.65-.066-1.414-.139-2.318-.217l-.09-.007-1.211.719 2.757 4.656 1.374-.832-1.671-2.809c.602.071 1.125.151 1.592.217zM23.424 94.459l-3.2-4.128-1.275.987 2.039 2.618-7.821 2.895 1.178 1.532 7.954-3.053zM24.347 102.334l.2.2.09-.087c1.68-1.678 3.416-3.409 1.524-5.337-1.927-1.925-3.678-.172-5.372 1.52l-.09.09c-1.626 1.616-3.468 3.454-1.562 5.374a2.441 2.441 0 001.729.82h.007c1.279 0 2.441-1.152 3.666-2.373zm-1.216-.884l-.184.181c-.7.707-1.572 1.583-2.21 1.583a.669.669 0 01-.49-.229.662.662 0 01-.221-.492c0-.639.884-1.5 1.588-2.191l.193-.188a14.651 14.651 0 012.092-1.875 1.325 1.325 0 01.671-.25.653.653 0 01.476.229c.637.643-.171 1.505-1.915 3.232zM32.075 103.083a2.432 2.432 0 00-1.041-1.635 2.272 2.272 0 00-2.853-.224 10.352 10.352 0 00-2.267 2.392l-.082.108c-1.058 1.36-2.059 2.646-1.9 3.914a2.442 2.442 0 001.022 1.614 2.564 2.564 0 001.572.615 2.409 2.409 0 001.315-.429 10.514 10.514 0 002.264-2.394l-.21-.191.262.125c1.067-1.357 2.073-2.641 1.918-3.895zm-1.715.047c.078.631-.737 1.68-1.765 3l-.181.233c-1.025 1.312-1.8 2.189-2.5 1.652-.219-.172-.431-.455-.137-1.131a8.836 8.836 0 011.143-1.7l.177-.226c1.5-1.932 2.264-2.842 2.971-2.283a.668.668 0 01.291.455zM35.774 104.893l-.1.016a11.456 11.456 0 01-1.769.134l-.186-.026-.938 1.588 1.6-.075-3.838 6.362 1.506.924 4.948-8.195z"
      />
      <g>
        <path
          d="M122.154 91.619v-30.54A61.077 61.077 0 100 61.079c0 .042 12.214.042 12.214 0a48.863 48.863 0 1197.726 0v30.54z"
          fill="#696868"
          fillRule="evenodd"
        />
        <path
          className="prefix__d"
          d="M22.468 24.31l.13.125a.987.987 0 001.524.019.955.955 0 00.042-1.5c-.994-.954-2.816 1.166-4.166-.127a1.649 1.649 0 01.047-2.49 1.531 1.531 0 012.5.016l-.573.6c-.485-.478-.957-.634-1.475-.092a.865.865 0 000 1.322c.99.95 2.78-1.2 4.2.165a1.878 1.878 0 01-2.776 2.531z"
        />
        <path
          className="prefix__e"
          d="M22.468 24.31l.13.125a.987.987 0 001.524.019.955.955 0 00.042-1.5c-.994-.954-2.816 1.166-4.166-.127a1.649 1.649 0 01.047-2.49 1.531 1.531 0 012.5.016l-.573.6c-.485-.478-.957-.634-1.475-.092a.865.865 0 000 1.322c.99.95 2.78-1.2 4.2.165a1.878 1.878 0 01-2.776 2.531z"
        />
        <path
          className="prefix__d"
          d="M24.733 16.144l.605-.525 1.244 4.022 1.555 1.788-.6.521-1.555-1.788-3.788-1.808.672-.584 2.889 1.475z"
        />
        <path
          className="prefix__e"
          d="M24.733 16.144l.605-.525 1.244 4.022 1.555 1.788-.6.521-1.555-1.788-3.788-1.808.672-.584 2.889 1.475z"
        />
        <path
          className="prefix__d"
          d="M29.458 17.989l.106.146a.983.983 0 001.494.295.952.952 0 00.313-1.466c-.8-1.119-2.978.634-4.069-.884a1.646 1.646 0 01.5-2.436 1.531 1.531 0 012.46.471l-.672.483c-.391-.556-.827-.794-1.435-.358a.867.867 0 00-.245 1.3c.8 1.112 2.95-.676 4.1.926a1.877 1.877 0 01-3.188 1.982z"
        />
        <path
          className="prefix__e"
          d="M29.458 17.989l.106.146a.983.983 0 001.494.295.952.952 0 00.313-1.466c-.8-1.119-2.978.634-4.069-.884a1.646 1.646 0 01.5-2.436 1.531 1.531 0 012.46.471l-.672.483c-.391-.556-.827-.794-1.435-.358a.867.867 0 00-.245 1.3c.8 1.112 2.95-.676 4.1.926a1.877 1.877 0 01-3.188 1.982z"
        />
        <path
          className="prefix__d"
          d="M33.851 9.981l.349.6-1.418.828 2.792 4.776-.683.4-2.794-4.778-1.414.829-.346-.6z"
        />
        <path
          className="prefix__e"
          d="M33.851 9.981l.349.6-1.418.828 2.792 4.776-.683.4-2.794-4.778-1.414.829-.346-.6z"
        />
        <path
          className="prefix__d"
          d="M37.735 14.986l-2.657-5.624 2.9-1.369.295.624-2.184 1.03.855 1.809 2.026-.957.295.622-2.026.959.919 1.949 2.229-1.053.295.624z"
        />
        <path
          className="prefix__e"
          d="M37.735 14.986l-2.657-5.624 2.9-1.369.295.624-2.184 1.03.855 1.809 2.026-.957.295.622-2.026.959.919 1.949 2.229-1.053.295.624z"
        />
        <path
          className="prefix__d"
          d="M42.327 12.916l-.7.236-1.974-5.9 1.22-.408 3.145 4.458h.014l-.151-5.459 1.242-.415 1.974 5.9-.752.252-1.755-5.249-.016.007.1 5.8-.712.238-3.374-4.708h-.017z"
        />
        <path
          className="prefix__e"
          d="M42.327 12.916l-.7.236-1.974-5.9 1.22-.408 3.145 4.458h.014l-.151-5.459 1.242-.415 1.974 5.9-.752.252-1.755-5.249-.016.007.1 5.8-.712.238-3.374-4.708h-.017z"
        />
        <path
          className="prefix__d"
          d="M52.332 5.735a1.47 1.47 0 00-.323-.865 1.053 1.053 0 00-.733-.151.974.974 0 00-.851.627c-.014.073-.141.25.028 1.305l.266 1.64c.245 1.508.768 1.6 1.371 1.508.238-.04.947-.24.761-1.442l.808-.132c.349 1.934-1.02 2.156-1.421 2.222-.766.123-1.946.262-2.335-2.118l-.28-1.734c-.28-1.736.405-2.354 1.612-2.549s1.786.356 1.9 1.56z"
        />
        <path
          className="prefix__e"
          d="M52.332 5.735a1.47 1.47 0 00-.323-.865 1.053 1.053 0 00-.733-.151.974.974 0 00-.851.627c-.014.073-.141.25.028 1.305l.266 1.64c.245 1.508.768 1.6 1.371 1.508.238-.04.947-.24.761-1.442l.808-.132c.349 1.934-1.02 2.156-1.421 2.222-.766.123-1.946.262-2.335-2.118l-.28-1.734c-.28-1.736.405-2.354 1.612-2.549s1.786.356 1.9 1.56z"
        />
        <path
          className="prefix__d"
          d="M55.087 9.93l-.436-6.206 3.2-.226.05.688-2.408.17.139 1.993 2.236-.156.049.688-2.236.156.151 2.151 2.46-.174.047.688z"
        />
        <path
          className="prefix__e"
          d="M55.087 9.93l-.436-6.206 3.2-.226.05.688-2.408.17.139 1.993 2.236-.156.049.688-2.236.156.151 2.151 2.46-.174.047.688z"
        />
        <path
          className="prefix__d"
          d="M60.19 6.835l-.035 2.858-.789-.009.073-6.216 2.146.026a1.4 1.4 0 011.47 1.569 1.345 1.345 0 01-1.154 1.407v.016c.714.12.968.365 1 1.614a9.207 9.207 0 00.2 1.63l-.827-.012a7.094 7.094 0 01-.217-2.069.819.819 0 00-.928-.8zm.009-.688l1.187.014c.568.007.851-.481.855-1.023a.841.841 0 00-.822-.957l-1.2-.016z"
        />
        <path
          className="prefix__e"
          d="M60.19 6.835l-.035 2.858-.789-.009.073-6.216 2.146.026a1.4 1.4 0 011.47 1.569 1.345 1.345 0 01-1.154 1.407v.016c.714.12.968.365 1 1.614a9.207 9.207 0 00.2 1.63l-.827-.012a7.094 7.094 0 01-.217-2.069.819.819 0 00-.928-.8zm.009-.688l1.187.014c.568.007.851-.481.855-1.023a.841.841 0 00-.822-.957l-1.2-.016z"
        />
        <path
          className="prefix__d"
          d="M68.172 3.896l-.057.688-1.63-.139-.467 5.511-.789-.066.464-5.511-1.63-.137.057-.688z"
        />
        <path
          className="prefix__e"
          d="M68.172 3.896l-.057.688-1.63-.139-.467 5.511-.789-.066.464-5.511-1.63-.137.057-.688z"
        />
        <path
          className="prefix__d"
          d="M68.583 10.246l.871-6.16.784.11-.87 6.16z"
        />
        <path
          className="prefix__e"
          d="M68.583 10.246l.871-6.16.784.11-.87 6.16z"
        />
        <path
          className="prefix__d"
          d="M70.765 10.568l1.216-6.1 3.025.6-.137.676-2.248-.448-.389 1.96 2.13.424-.134.676-2.132-.424-.554 2.787z"
        />
        <path
          className="prefix__e"
          d="M70.765 10.568l1.216-6.1 3.025.6-.137.676-2.248-.448-.389 1.96 2.13.424-.134.676-2.132-.424-.554 2.787z"
        />
        <path
          className="prefix__d"
          d="M74.68 11.417l1.574-6.018.766.2-1.574 6.018z"
        />
        <path
          className="prefix__e"
          d="M74.68 11.417l1.574-6.018.766.2-1.574 6.018z"
        />
        <path
          className="prefix__d"
          d="M80.94 8.612a1.454 1.454 0 00.12-.914 1.039 1.039 0 00-.577-.478.96.96 0 00-1.044.156c-.047.057-.243.153-.587 1.166l-.535 1.576c-.492 1.442-.078 1.777.5 1.974.229.075.952.231 1.35-.919l.775.264c-.6 1.873-1.916 1.425-2.3 1.3-.735-.25-1.845-.681-1.067-2.966l.565-1.666c.565-1.666 1.461-1.89 2.62-1.5s1.411 1.155.95 2.271z"
        />
        <path
          className="prefix__e"
          d="M80.94 8.612a1.454 1.454 0 00.12-.914 1.039 1.039 0 00-.577-.478.96.96 0 00-1.044.156c-.047.057-.243.153-.587 1.166l-.535 1.576c-.492 1.442-.078 1.777.5 1.974.229.075.952.231 1.35-.919l.775.264c-.6 1.873-1.916 1.425-2.3 1.3-.735-.25-1.845-.681-1.067-2.966l.565-1.666c.565-1.666 1.461-1.89 2.62-1.5s1.411 1.155.95 2.271z"
        />
        <path
          className="prefix__d"
          d="M85.302 8.541l.917.424-.773 6.5-.806-.372.214-1.534-2.182-1.008-1.046 1.15-.726-.337zm.13.867l-.014-.007-2.276 2.6 1.8.834z"
        />
        <path
          className="prefix__e"
          d="M85.302 8.541l.917.424-.773 6.5-.806-.372.214-1.534-2.182-1.008-1.046 1.15-.726-.337zm.13.867l-.014-.007-2.276 2.6 1.8.834z"
        />
        <path
          className="prefix__d"
          d="M91.707 11.949l-.344.6-1.418-.82-2.766 4.785-.688-.4 2.771-4.785-1.418-.82.346-.6z"
        />
        <path
          className="prefix__e"
          d="M91.707 11.949l-.344.6-1.418-.82-2.766 4.785-.688-.4 2.771-4.785-1.418-.82.346-.6z"
        />
        <path
          className="prefix__d"
          d="M89.363 17.888l3.508-5.138.654.447-3.508 5.138z"
        />
        <path
          className="prefix__e"
          d="M89.363 17.888l3.508-5.138.654.447-3.508 5.138z"
        />
        <path
          className="prefix__d"
          d="M92.667 17.397l1.291-1.579a1.956 1.956 0 113.025 2.476l-1.29 1.582c-1.091 1.331-2.017 1.454-3.035.62s-1.081-1.765.009-3.1m2.377 1.991l1.331-1.626c.822-1.006.158-1.607-.035-1.765s-.914-.693-1.739.313l-1.331 1.626c-.86 1.053-.773 1.572-.193 2.045s1.105.459 1.967-.594"
        />
        <path
          className="prefix__e"
          d="M92.667 17.397l1.291-1.579a1.956 1.956 0 113.025 2.476l-1.29 1.582c-1.091 1.331-2.017 1.454-3.035.62s-1.081-1.765.009-3.099zm2.377 1.991l1.331-1.626c.822-1.006.158-1.607-.035-1.765s-.914-.693-1.739.313l-1.331 1.626c-.86 1.053-.773 1.572-.193 2.045s1.105.46 1.968-.593z"
        />
        <path
          className="prefix__d"
          d="M102.745 21.379l-4.5 4.3-.749-.785 2.2-5.5-.012-.014-3.9 3.73-.488-.511 4.5-4.3.773.811-2.177 5.431.012.012 3.85-3.68z"
        />
        <path
          className="prefix__e"
          d="M102.745 21.379l-4.5 4.3-.749-.785 2.2-5.5-.012-.014-3.9 3.73-.488-.511 4.5-4.3.773.811-2.177 5.431.012.012 3.85-3.68z"
        />
      </g>
    </svg>
  )
}

export default SvgComponent